export enum PermissionTypeEnum {
  EXPORT_CONTACT = 'EXPORT_CONTACT'
}
